/**
 * Dev/runtime fixes loaded before the app mounts.
 * Prevents CRA's error overlay from treating ResizeObserver loop warnings as fatal
 * (common when opening Rsuite SelectPicker menus).
 */
const resizeObserverLoopPattern = /ResizeObserver loop/;

function suppressResizeObserverOverlayErrors() {
  window.addEventListener(
    "error",
    (event) => {
      if (resizeObserverLoopPattern.test(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  const previousOnError = window.onerror;
  window.onerror = (
    message,
    source,
    lineno,
    colno,
    error
  ): boolean | undefined => {
    if (
      typeof message === "string" &&
      resizeObserverLoopPattern.test(message)
    ) {
      return true;
    }

    if (typeof previousOnError === "function") {
      return (
        previousOnError(message, source, lineno, colno, error) ?? undefined
      );
    }

    return undefined;
  };
}

function patchResizeObserver() {
  if (typeof window.ResizeObserver === "undefined") {
    return;
  }

  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class PatchedResizeObserver extends (
    NativeResizeObserver
  ) {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

suppressResizeObserverOverlayErrors();
patchResizeObserver();
